export default "/images/fb25114c4a6780ca9e23d6d1fc1973de.avif";